import { DynamicContentType } from '../../types/content.types.js'
import { FileEntryBM } from '../../types/fileEntry.types.js'
import { LucideIconName } from '../../types/lucide.types.js'

export type ImageCard = {
  image?: FileEntryBM
  header: string
  paragraph: string
  buttonText: string
  buttonLink: string
}

export type ImageCardsData = {
  marginBottom: string
  marginTop: string
  cards: ImageCard[]
}

const defaultCard: ImageCard = {
  image: undefined,
  header: 'Min rubrik',
  paragraph:
    'Lorem ipsum dolor sit amet. Hic rerum adipisci hic commodi sapiente ad omnis dolorum At dicta cumque aut saepe aperiam et maxime.',
  buttonText: 'Läs mer',
  buttonLink: '/',
}

export const imageCards: DynamicContentType<ImageCardsData> = {
  name: 'imageCards',
  viewName: 'Bildkort',
  featureKey: 'imageCards',
  icon: LucideIconName.IdCardLanyard,
  default: false,
  uuid: '',
  data: {
    cards: [defaultCard, defaultCard, defaultCard],
    marginBottom: '1rem',
    marginTop: '1rem',
  },
}
